/** Web ve mobil arayüz metinleri. Modül bazında alt anahtarlar. */
export const ui = {
  common: {
    save: "Kaydet",
    cancel: "Vazgeç",
    close: "Kapat",
    back: "Geri",
    continue: "Devam",
    loading: "Yükleniyor…",
    retry: "Tekrar dene",
    search: "Ara",
    edit: "Düzenle",
    delete: "Sil",
    undo: "Geri al",
    yes: "Evet",
    no: "Hayır",
    optional: "isteğe bağlı",
    all: "Tümü",
    none: "Yok",
    today: "Bugün",
    download: "İndir",
    export: "Dışa aktar",
  },
  leave: {
    genericType: "İzinli",
  },
  time: {
    minutes_one: "{count} dakikadır",
    minutes_other: "{count} dakikadır",
    hours_one: "{count} saattir",
    hours_other: "{count} saattir",
    days_one: "{count} gündür",
    days_other: "{count} gündür",
  },
};
